import React, { Component } from 'react'
import './main.css'

class TextAreaInput extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isEmpty: false
        }
    }

    async validateInput() {
        if (this.props.value.trim().length === 0 && !this.props.notRequired) {
            await this.setState({ isEmpty: true })
            return false
        } else {
            await this.setState({ isEmpty: false })
            return true
        }
    }

    render() {
        return (
            <React.Fragment>
                <label className="data-label"><strong>{this.props.label}</strong></label>
                <textarea value={this.props.value} onChange={async e => {await this.props.onChange(e, this.props.stateProp); await this.validateInput()}} className="data-textarea data-text-input"></textarea>
                {this.state.isEmpty && <p className="text-input-error-p" >{this.props.label} boş bırakılamaz</p>}
            </React.Fragment>
        )
    }
}

export default TextAreaInput